import React, { useContext, useLayoutEffect } from 'react';

import { Redirect } from 'react-router-dom';

import { UserModules } from '@vyce/core/src/types';

import { useTypedSelector } from '../../hooks';
import { InvitesContext } from '../../store/invites-context';
import { isPhoneVerificationPending } from '../../store/action-creators/user';
import { EmployeeAppDialog } from './components/EmployeeAppDialog';
import { EmployerOnboardingTrack } from './employer/EmployerOnboardingTrack';

const hasOnboardedRole = (positionsCount: number, employeeUuid?: string) =>
  positionsCount > 0 || !!employeeUuid;

const hasEmployeeInvite = (modules: UserModules) => modules.pay || modules.teams || modules.time;

export const Onboarding: React.FC = () => {
  const user = useTypedSelector(state => state.user);
  const { prepareOnboarding, isPreparingOnboarding } = useContext(InvitesContext);
  const phonePending = isPhoneVerificationPending(user);

  useLayoutEffect(() => {
    if (phonePending) return;
    prepareOnboarding();
  }, [prepareOnboarding, phonePending]);

  if (phonePending) {
    return <Redirect to="/auth/verify-phone" />;
  }

  if (!isPreparingOnboarding) {
    if (hasOnboardedRole(user.positions?.length ?? 0, user.employee?.uuid)) {
      return <Redirect to="/dashboard" />;
    }
    if (hasEmployeeInvite(user.inviteModules)) {
      return <EmployeeAppDialog />;
    }
  }

  return <EmployerOnboardingTrack />;
};
